<script>
    import MenuItem from "./MenuItem.svelte"
</script>

<nav>
    <ul>
        <slot></slot>
    </ul>
</nav>

<style>
    nav {
        width: 100%;
        flex-grow: 1;
        display: block;
    }

    ul {
        margin: 0;
        padding: 0;
        list-style: none;
        display: flex;
        flex-flow: column;
    }
</style>